import { computed } from 'vue'
import { storeToRefs } from 'pinia'

import { useContentBlockStore } from '../stores/content-block-store'
import { getCombinedHeightOfForwardTextBlocks, getNextEnabledBlock } from '../utils/checkContentBlockFloat'

export function useCombinedHeightOfTextBlocks (id: string) {
  const contentBlockStore = useContentBlockStore()
  const { contentBlockList } = storeToRefs(contentBlockStore)

  return computed(() => {
    const currentIndex = contentBlockList.value.findIndex(block => block.id === id)
    const nextBlock = getNextEnabledBlock(currentIndex, contentBlockList.value)
    if (!nextBlock) return 0
    return getCombinedHeightOfForwardTextBlocks(nextBlock, contentBlockList.value)
  })
}
